"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructQrLinkUrl = exports.addInviteIdToURL = exports.getQueryParams = void 0;
const web_env_1 = require("@snapchat/web-env");
const urls_1 = require("./urls");
const getQueryParams = () => {
    if (typeof (0, web_env_1.getWindow)() !== "undefined") {
        return (0, web_env_1.getWindow)()?.location.search || "";
    }
    return "";
};
exports.getQueryParams = getQueryParams;
const addInviteIdToURL = (url) => {
    if (url === "")
        return url;
    const uriParams = new URLSearchParams((0, web_env_1.getWindow)()?.location.search);
    const parsedUrl = new URL(url);
    const inviteId = uriParams.get("invite_id");
    if (inviteId && inviteId !== "")
        parsedUrl.searchParams.set("invite_id", inviteId);
    return parsedUrl.toString();
};
exports.addInviteIdToURL = addInviteIdToURL;
const constructQrLinkUrl = (webClientId = "", webPageViewTraceId = "") => {
    const baseURL = urls_1.DOWNLOAD_QR_LINK_URL;
    const params = new URLSearchParams({
        af_dp: "https://link.snapchat.com/unlock?web_client_id=" + webClientId,
        trace_id: webPageViewTraceId,
    });
    return `${baseURL}?${params.toString()}`;
};
exports.constructQrLinkUrl = constructQrLinkUrl;
//# sourceMappingURL=urlUtils.js.map